module.exports = __webpack_public_path__ + "img/co2.02457473.svg";